export enum KlearlyCountryAlpha2Code {
  Netherlands = "nl",
  Italy = "it",
  France = "fr",
  Germany = "de",
  Belgium = "be",
}

export const KlearlyCountryAlpha2Codes = Object.values(
  KlearlyCountryAlpha2Code
) as string[];
